module.exports = __webpack_public_path__ + "static/media/img5.73030fd9.jpeg";